export default "<!-- <app-sidebar  [isOpen]=\"sideBarIsOpened\"></app-sidebar> -->\r\n<router-outlet></router-outlet>"